module.exports = __webpack_public_path__ + "img/thumbnail_SiberianTiger_m_leucistic.7d8fdd22.png";